import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const LogginButton = styled.div`
  flex-direction: row-reverse;
`

export const ForgotDetailsLink = styled(Link)`
  font-size: 14px;
  line-height: 20 px;
  text-decoration-line: underline;
  color: rgba(107, 124, 147, 0.54);
`



// WEBPACK FOOTER //
// src/components/LoginForm/styles.js